import { HttpHeaders, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { HeaderDataStore } from "../store/header-data.store";
import { isOAuthProtectedResource } from "@v1/core/oauth/oauth-resource-server.config";

export const CoreInterceptor: HttpInterceptorFn = (req, next) => {
  const headerStore = inject(HeaderDataStore);
  const oauthService = inject(OAuthService, { optional: true });
  let headers = req.headers ? req.headers : new HttpHeaders();

  const { businessId, accessToken } = headerStore;

  if (businessId() && !headers.has("business-id")) {
    headers = headers.set("business-id", businessId()!);
  }

  if (businessId() && !headers.has("X-Company-ID")) {
    headers = headers.set("X-Company-ID", businessId()!);
  }

  if (!headers.has("Authorization") && isOAuthProtectedResource(req.url)) {
    const token = oauthService ? oauthService.getAccessToken() : accessToken();
    if (token) {
      headers = headers.set("Authorization", `Bearer ${token}`);
    }
  }

  if (req.method != "DELETE" && !headers.has("Content-Type")) {
    headers = headers.set("Content-Type", "application/json");
  }
  if (!headers.has("Accept")) {
    headers = headers.set("Accept", "application/json");
  }

  return next(req.clone({headers: headers}));
};
